import React from 'react';
import {
    readBucketCookieServer,
    writeBucketCookie,
} from '../../../state/bucketCookie';
import { DEFAULT_LAYOUT, useLayout, type Layout } from './LayoutStore';

// The users preferred layout must be stored in a cookie, in order for it to be
// available on the server-side for SSR. Using localStorage is not an option,
// since localStorage can't be accessed on the server. Another option is to pass
// the preferred layout as a query parameter, but that will make the search page
// URL longer and more complicated.

const LAYOUT_KEY = 'searchResultLayout';

export function useLayoutCookieState() {
    const { layout } = useLayout();

    React.useEffect(() => {
        writeBucketCookie(LAYOUT_KEY, layout);
    }, [layout]);
}

export function parseLayoutCookie(cookies: Record<string, string>): Layout {
    try {
        const layoutValue = readBucketCookieServer(cookies, LAYOUT_KEY);
        return (layoutValue ?? DEFAULT_LAYOUT) as Layout;
    } catch {
        return DEFAULT_LAYOUT;
    }
}
